<template>
  <div class="container page service-page">
    <van-nav-bar
      :title="$t('my.online_service')"
      class="nav-bar"
      :border="false"
    >
      <template #left>
        <van-icon name="arrow-left" @click="back()" />
      </template>
    </van-nav-bar>
    <div class="iframe-wrap">
      <iframe
        id="iframe_web"
        class="service-iframe"
        frameborder="0"
        :src="kefuUrl"
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    kefuUrl() {
      const info = this.$store.getters.getBaseInfo || {}
      return info.kefu || 'https://hao.360.com/'
    }
  },
  methods: {
    back() {
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        this.$router.replace({ path: '/ServiceOnline' })
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";

.service-page {
  background: #fff;
}

.iframe-wrap {
  flex: 1;
  min-height: 0;
  width: 100%;
  overflow: hidden;
}

.service-iframe {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}
</style>
